// Proste polecenie aplikacji znajomemu: natywny share sheet (iOS/Android/web),
// a gdy niedostępny — kopiowanie linku do schowka. Bez kodów, ref i śledzenia.

const SHARE_URL = "https://matematly.pl";
const SHARE_TEXT =
  "Uczę się matematyki do matury na Matematly — sprawdź, może ci pomóc. Przetestujesz za darmo, bez karty 👇";

// Zwraca: "shared" | "copied" | "cancelled" | "error"
export async function shareMatematly() {
  if (navigator.share) {
    try {
      await navigator.share({ title: "Matematly", text: SHARE_TEXT, url: SHARE_URL });
      return "shared";
    } catch (e) {
      if (e && e.name === "AbortError") return "cancelled";
      // brak wsparcia / błąd — spróbuj skopiować
    }
  }

  try {
    await navigator.clipboard.writeText(`${SHARE_TEXT} ${SHARE_URL}`);
    return "copied";
  } catch (e) {
    return "error";
  }
}
